var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32c8.837 0 16-7.163 16-16s-7.163-16-16-16c-8.837 0-16 7.163-16 16s7.163 16 16 16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.458 13.683c0.324 0 0.775-0.168 1.241-0.72v0.637h1.072v-5.769h-1.072v4.379c-0.131 0.164-0.422 0.432-0.631 0.432-0.23 0-0.285-0.156-0.285-0.388v-4.424h-1.073v4.823c0 0.569 0.175 1.030 0.749 1.030z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.253 13.707c-1.040 0-1.572-0.529-1.572-1.546v-2.827c0-0.926 0.627-1.55 1.572-1.55 0.87 0 1.541 0.647 1.541 1.55v2.827c0 0.97-0.679 1.546-1.541 1.546zM15.232 8.878c-0.301 0-0.447 0.234-0.447 0.55v2.684c0 0.304 0.172 0.546 0.468 0.546 0.289 0 0.449-0.232 0.449-0.546v-2.684c0-0.323-0.141-0.55-0.47-0.55z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.124 13.599h1.208v-3.173l1.405-4.648h-1.227l-0.774 3.126-0.833-3.126h-1.216l1.436 4.648v3.173z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.57 14.911c-1.358 0-2.459 1.102-2.459 2.46v6.213c0 1.359 1.101 2.459 2.459 2.459h12.643c1.359 0 2.46-1.1 2.46-2.459v-6.213c0-1.359-1.101-2.46-2.46-2.46h-12.643zM11.255 24.203h-1.15v-6.367h-1.191v-1.081h3.531v1.081h-1.19v6.367zM19.28 23.066c0 0.68-0.254 1.208-0.934 1.208-0.374 0-0.686-0.137-0.97-0.492v0.422h-1.032v-7.449h1.032v2.398c0.23-0.281 0.543-0.513 0.908-0.513 0.748 0 0.996 0.632 0.996 1.377v3.048zM23.056 21.585h-1.954v1.036c0 0.412 0.035 0.769 0.446 0.769 0.432 0 0.457-0.29 0.457-0.769v-0.382h1.051v0.413c0 1.058-0.455 1.7-1.531 1.7-0.976 0-1.474-0.711-1.474-1.7v-2.466c0-0.955 0.629-1.616 1.551-1.616 0.98 0 1.454 0.622 1.454 1.616v1.398zM14.325 24.204v-0.606c-0.188 0.223-0.384 0.393-0.588 0.511-0.55 0.315-1.306 0.309-1.306-0.807v-4.592h1.022v4.211c0 0.221 0.054 0.371 0.272 0.371 0.199 0 0.476-0.255 0.6-0.412v-4.17h1.022v5.494h-1.022z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.556 19.532c-0.379 0-0.457 0.267-0.457 0.644v0.556h0.903v-0.556c0-0.372-0.080-0.644-0.446-0.644z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.585 19.566c-0.072 0.036-0.141 0.092-0.211 0.167v3.424c0.084 0.089 0.164 0.155 0.242 0.194 0.166 0.084 0.41 0.091 0.522-0.057 0.060-0.077 0.089-0.203 0.089-0.379v-2.838c0-0.185-0.037-0.326-0.109-0.422-0.123-0.163-0.354-0.18-0.533-0.090z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.0df5ea7a48487784eff1b6094b6e2c38.svg";
export { ForwardRef as ReactComponent };